import { render, staticRenderFns } from "./marking.vue?vue&type=template&id=42c496fa&scoped=true&"
import script from "./marking.vue?vue&type=script&lang=js&"
export * from "./marking.vue?vue&type=script&lang=js&"
import style0 from "./marking.vue?vue&type=style&index=0&id=42c496fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c496fa",
  null
  
)

export default component.exports